import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Zap } from "lucide-react";
import { NAV, BRAND } from "@/lib/site";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "bg-ink-900/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-4 md:px-10">
        <Link to="/" data-testid="nav-logo" className="group flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-full border border-amber/50 text-amber transition-colors duration-500 group-hover:bg-amber group-hover:text-black">
            <Zap className="h-4 w-4" strokeWidth={1.75} />
          </span>
          <span className="font-head text-2xl font-medium leading-none tracking-tight text-white">
            7 Electric Advice
          </span>
        </Link>

        <nav className="hidden items-center gap-10 md:flex">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-xs font-medium uppercase tracking-[0.18em] transition-colors hover:text-amber ${
                  isActive ? "text-amber" : "text-white/60"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-book-btn"
            className="rounded-full border border-amber/60 bg-amber/10 px-6 py-2.5 text-xs font-medium uppercase tracking-[0.18em] text-amber transition-colors duration-300 hover:bg-amber hover:text-black"
          >
            Book a Consult
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="text-white md:hidden"
          aria-label="Menu"
        >
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-white/10 bg-ink-900/95 backdrop-blur-xl md:hidden">
          <div className="flex flex-col gap-1 px-5 py-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className="py-3 font-head text-2xl uppercase tracking-tight text-white/80"
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="mt-3 rounded-full bg-amber py-3 text-center font-medium uppercase tracking-[0.2em] text-black"
            >
              Book a Consult
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
